import { gql } from "apollo-boost"
export const UPDATE_PROJECT_MONTH_STATUS_QUERY = gql`
    mutation UpdateProjectMonthStatusData ($id: ID!, $data: CreateProjectMonthStatusInput!) {
        UpdateProjectMonthStatusData(id: $id, data: $data )
    }
`
